import React, { FC, useMemo } from 'react';

import styled from 'styled-components';

//constants
import aampeTheme from '../../../constants/aampeTheme';

//hooks
import useCMSPlaceholderQuery from '../../../hooks/cms-placeholders/useCMSPlaceholderQuery';

interface FormulaAlternateCmsDataViewProps {
    headerName: string;
    cmsPlaceholderId: string;
}
const FormulaAlternateCmsDataView: FC<FormulaAlternateCmsDataViewProps> = ({
    headerName,
    cmsPlaceholderId,
}) => {
    const { data } = useCMSPlaceholderQuery();

    const currentPlaceholderName = useMemo<string | undefined>(() => {
        return (data?.messageable ?? []).find((d) => d.id === cmsPlaceholderId)
            ?.name;
    }, [cmsPlaceholderId, data]);
    return (
        <Content>
            <RegularHeaderText>{headerName}</RegularHeaderText>
            <CmsAndLinkWrapper>{currentPlaceholderName}</CmsAndLinkWrapper>
        </Content>
    );
};

const Content = styled.div({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderLeft: `1px solid ${aampeTheme.colors.interactiveWG01}`,
});

const RegularHeaderText = styled.div({
    display: 'flex',
    padding: aampeTheme.spacing4(2, 4),
    fontSize: aampeTheme.size.font.textMedium,
    lineHeight: '24px',
    fontWeight: 500,
    border: `1px solid ${aampeTheme.colors.interactiveWG01}`,
    borderTop: '0px',
    borderRight: '0px',
    color: aampeTheme.colors.textAccessibleWG01,
    width: 220,
    height: '88px',
    backgroundColor: aampeTheme.colors.backgroundWG02,
    borderLeft: '0px',
});

const CmsAndLinkWrapper = styled.div({
    fontSize: aampeTheme.size.font.default,
    lineHeight: '24px',
    fontWeight: 400,
    color: aampeTheme.colors.neutral09,
    border: `1px solid ${aampeTheme.colors.interactiveWG01}`,
    borderTop: '0px',
    padding: aampeTheme.spacing4(2, 4),
    minHeight: '45px',
    borderLeft: '0px',
});

export default FormulaAlternateCmsDataView;
